(()=>{
 if(customElements.get('rw-desktop-hero-video'))return;
 customElements.define('rw-desktop-hero-video',class extends HTMLElement{
 connectedCallback(){
  if(this.controller)return;this.controller=new AbortController();const signal=this.controller.signal;
  const video=this.querySelector('video');if(!video)return;
  const photo=()=>{video.style.opacity='0';video.style.pointerEvents='none';video.controls=false;this.dataset.playback='photo';};
  const playing=()=>{clearTimeout(this.timer);video.style.opacity='1';video.style.pointerEvents='auto';video.controls=true;this.dataset.playback='shopify';};
  const wide=matchMedia('(min-width:761px)');
  const start=()=>{if(!wide.matches){video.pause();photo();return;}photo();video.muted=true;video.defaultMuted=true;video.playsInline=true;
   if(!video.getAttribute('src'))video.src=video.dataset.nativeHeroSrc;
   video.preload='auto';clearTimeout(this.timer);this.timer=setTimeout(photo,12000);video.play().catch(photo);
  };
  video.addEventListener('playing',playing,{signal});video.addEventListener('error',photo,{signal});video.addEventListener('waiting',photo,{signal});
  wide.addEventListener('change',start,{signal});start();
 }
 disconnectedCallback(){clearTimeout(this.timer);this.controller?.abort();this.controller=null;this.querySelector('video')?.pause();}
 });
})();
